import * as React from "react";
import { forwardRef } from "react";
const LogoVkSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#07F" }),
    React.createElement("path", { fill: "#fff", d: "M12.655 16.667c-5.011 0-7.87-3.504-7.988-9.334h2.51c.082 4.28 1.933 6.092 3.398 6.466V7.333h2.364v3.69c1.447-.158 2.968-1.84 3.481-3.69h2.364c-.394 2.28-2.043 3.962-3.216 4.653 1.173.56 3.05 2.027 3.765 4.68h-2.601c-.56-1.774-1.952-3.148-3.793-3.335v3.336z" }));
const ForwardRef = forwardRef(LogoVkSVG);
export default ForwardRef;
//# sourceMappingURL=LogoVk.js.map